export default "__VITE_ASSET__DE1zxvye__"